var Trix = require("trix")
require('@rails/actiontext')